<template>
    <video autoplay="" muted="" loop="" id="background-video" style="opacity: 1;">
        <source src="/site_assets/backgrounds/old_cam.mp4" type="video/mp4">
    </video>
    <div class="contact">
      <section class="partie">
        <h2>Legal Notice</h2>
        <p>Owned by Emily-Rose Strich.<br>email: er.strich@hotmail.fr <br>All texts, images, and artworks on this site are the property of the author. Reproduction is not allowed without permission.</p>
      </section>

      <section class="partie">
        <h2>previous versions</h2>
        <div class="versions">
          <a href="/versions/2024/index.html" target="_blank">2024</a>
          <a href="/versions/2023/index.html" target="_blank">2023</a>
          <a href="/versions/2022/index.html" target="_blank">2022</a>
          <a href="/versions/2021/index.html" target="_blank">2021</a>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage'
  };
  </script>
  
  <style scoped>
    video {
    object-fit: contain;
    overflow-clip-margin: content-box;
    overflow: clip;
  }
  #background-video {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: -10;
  }
  .contact {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 20px;
  }
  .partie {
    margin-top: 20px;
    padding: 20px;
    min-width: 20%;
    max-width: 50%;
    background-image: url(../../public/site_assets/papers/paper.jpg);
    background-position-x: center;
    background-position-y: center;
  }

  .versions {
    display: flex;
    justify-content: center;
    gap: 30px;
    font-size: 20px;
  }

  a {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 20px;
    }

    .partie {
      max-width: 80%;
    }

    h2 {
      padding: 10px 0;
    }
  }

</style>